module.exports = __webpack_public_path__ + "img/done_step.17021fd3.svg";